import { useState, useEffect } from 'react';
import { getComments, createComment } from '../services/api';

function CommentSection({ referenceType, referenceId, currentUserId, currentUserName }) {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (referenceType && referenceId) {
      loadComments();
    }
  }, [referenceType, referenceId]);

  const loadComments = async () => {
    try {
      const data = await getComments(referenceType, referenceId);
      setComments(data);
    } catch (error) {
      console.error('Error loading comments:', error);
    }
  };

  const handleAddComment = async (e) => {
    e.preventDefault();

    if (!newComment.trim()) {
      alert('Please enter a comment');
      return;
    }

    setLoading(true);
    try {
      const commentData = {
        referenceType,
        referenceId,
        userId: currentUserId,
        comment: newComment.trim()
      };

      await createComment(commentData);
      setNewComment('');
      loadComments();
    } catch (error) {
      alert('Error adding comment: ' + error.message);
    } finally {
      setLoading(false);
    }
  };


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) {
      return 'just now';
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 604800) {
      const days = Math.floor(diffInSeconds / 86400);
      return `${days} day${days > 1 ? 's' : ''} ago`;
    } else {
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    }
  };

  return (
    <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '2px solid #ecf0f1' }}>
      <h3 style={{ margin: '0 0 15px 0', fontSize: '16px', color: '#3D1F1F' }}>
        Comments ({comments.length})
      </h3>

      {/* Add Comment Form */}
      <form onSubmit={handleAddComment} style={{ marginBottom: '20px' }}>
        <textarea
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Add a comment..."
          rows={3}
          style={{
            width: '100%',
            padding: '10px',
            border: '1px solid #dee2e6',
            borderRadius: '4px',
            fontSize: '14px',
            resize: 'vertical',
            fontFamily: 'inherit'
          }}
        />
        <button
          type="submit"
          disabled={loading || !newComment.trim()}
          style={{
            marginTop: '8px',
            padding: '8px 16px',
            background: loading ? '#95a5a6' : '#3498db',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          {loading ? 'Adding...' : 'Add Comment'}
        </button>
      </form>

      {/* Comments List */}
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {comments.length === 0 ? (
          <div style={{
            padding: '20px',
            textAlign: 'center',
            color: '#7f8c8d',
            fontSize: '14px',
            background: '#f8f9fa',
            borderRadius: '4px'
          }}>
            No comments yet. Be the first to comment!
          </div>
        ) : (
          comments.map((comment) => (
            <div
              key={comment.id}
              style={{
                padding: '12px',
                background: '#f8f9fa',
                borderRadius: '6px',
                marginBottom: '10px',
                border: '1px solid #e9ecef'
              }}
            >
              <div style={{ marginBottom: '8px' }}>
                <div style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#3D1F1F'
                }}>
                  {comment.userName}
                </div>
                <div style={{
                  fontSize: '12px',
                  color: '#7f8c8d',
                  marginTop: '2px'
                }}>
                  {formatDate(comment.createdAt)}
                </div>
              </div>
              <div style={{
                fontSize: '14px',
                color: '#2c3e50',
                lineHeight: '1.5',
                whiteSpace: 'pre-wrap'
              }}>
                {comment.comment}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default CommentSection;
